import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconProp } from '@fortawesome/angular-fontawesome/types';
import { faPhone, faVideo, faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import { FaIconComponent } from '@akostm/orbit-ui';
import { HeaderButtonType } from '../../../interfaces';
import { CdkOverlayOrigin, OverlayModule } from '@angular/cdk/overlay';

@Component({
  selector: 'shared-header-bar',
  standalone: true,
  imports: [CommonModule, FaIconComponent, OverlayModule],
  templateUrl: './header-bar.component.html',
  styleUrl: './header-bar.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderBarComponent {
  title = input.required<string>();
  buttonsHidden = input<boolean>(false);
  buttonClick = output<{ eventOrigin?: CdkOverlayOrigin; type: HeaderButtonType }>();

  readonly HeaderButtonTypeEnum = HeaderButtonType;

  videoIcon: IconProp = faVideo;
  phoneIcon: IconProp = faPhone;
  ellipsisIcon: IconProp = faEllipsisVertical;
}
